"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApolloOfflineClient = void 0;
var apollo_client_1 = __importDefault(require("apollo-client"));
var offix_scheduler_1 = require("offix-scheduler");
var apollo_cache_persist_1 = require("apollo-cache-persist");
var offix_cache_1 = require("offix-cache");
var apollo_1 = require("./apollo");
var ApolloOfflineClientConfig_1 = require("./config/ApolloOfflineClientConfig");
var ApolloOfflineClientConfigValidator_1 = require("./config/ApolloOfflineClientConfigValidator");
var ApolloOfflineClient = /** @class */ (function (_super) {
    __extends(ApolloOfflineClient, _super);
    function ApolloOfflineClient(options) {
        var _this = this;
        var config = new ApolloOfflineClientConfig_1.ApolloOfflineClientConfig(options);
        ApolloOfflineClientConfigValidator_1.validateConfig(config);
        _this = _super.call(this, config) || this;
        _this.initialized = false;
        _this.conflictListener = config.conflictListener;
        _this.mutationCacheUpdates = config.mutationCacheUpdates;
        _this.conflictProvider = config.conflictProvider;
        _this.inputMapper = config.inputMapper;
        if (config.cachePersistor) {
            if (!(config.cachePersistor instanceof apollo_cache_persist_1.CachePersistor)) {
                throw new Error("Error: options.cachePersistor is not a CachePersistor instance");
            }
            _this.persistor = config.cachePersistor;
        }
        else {
            _this.persistor = new apollo_cache_persist_1.CachePersistor({
                cache: _this.cache,
                serialize: false,
                storage: config.cacheStorage,
                maxSize: false,
                debug: false
            });
        }
        _this.scheduler = new offix_scheduler_1.OffixScheduler({
            executor: _this,
            storage: config.offlineStorage,
            networkStatus: config.networkStatus,
            serializer: apollo_1.ApolloOperationSerializer,
            offlineQueueListener: config.offlineQueueListener
        });
        _this.queue = _this.scheduler.queue;
        _this.networkStatus = _this.scheduler.networkStatus;
        _this.offlineStore = _this.scheduler.offlineStore;
        return _this;
    }
    ApolloOfflineClient.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.persistor) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.persistor.restore()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Error restoring Apollo cache from storage.", error_1);
                        console.error("Cache persistence will not be available.");
                        return [3 /*break*/, 4];
                    case 4:
                        // Optimistic Responses
                        this.queue.registerOfflineQueueListener({
                            onOperationEnqueued: function (operation) {
                                apollo_1.addOptimisticResponse(_this, operation);
                            },
                            onOperationSuccess: function (operation, result) {
                                apollo_1.replaceClientGeneratedIDsInQueue(_this.scheduler.queue, operation, result);
                                apollo_1.removeOptimisticResponse(_this, operation);
                            },
                            onOperationFailure: function (operation, error) {
                                apollo_1.removeOptimisticResponse(_this, operation);
                            },
                            onOperationRequeued: function (operation) {
                                if (_this.mutationCacheUpdates) {
                                    apollo_1.restoreOptimisticResponse(_this, _this.mutationCacheUpdates, operation);
                                }
                            }
                        });
                        return [4 /*yield*/, this.scheduler.init()];
                    case 5:
                        _a.sent();
                        this.initialized = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    ApolloOfflineClient.prototype.execute = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.mutate(options)];
            });
        });
    };
    ApolloOfflineClient.prototype.offlineMutate = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var mutationOptions;
            return __generator(this, function (_a) {
                if (!this.initialized) {
                    throw new Error("cannot call client.offlineMutate until client is initialized");
                }
                mutationOptions = this.createOfflineMutationOptions(options);
                return [2 /*return*/, this.scheduler.execute(mutationOptions)];
            });
        });
    };
    /**
     * Add new listener for listening for queue changes
     *
     * @param listener
     */
    ApolloOfflineClient.prototype.registerOfflineEventListener = function (listener) {
        this.scheduler.registerOfflineQueueListener(listener);
    };
    /**
     * Add new listener for conflict related events
     *
     * @param listener
     */
    ApolloOfflineClient.prototype.addConflictListener = function (listener) {
        this.conflictListener.addConflictListener(listener);
    };
    /**
     * remove a conflict listener
     *
     * @param listener
     */
    ApolloOfflineClient.prototype.removeConflictListener = function (listener) {
        this.conflictListener.removeConflictListener(listener);
    };
    ApolloOfflineClient.prototype.createOfflineMutationOptions = function (options) {
        options.inputMapper = this.inputMapper;
        var offlineMutationOptions = offix_cache_1.createMutationOptions(options);
        offlineMutationOptions.context.conflictBase = apollo_1.getBaseStateFromCache(this.cache, this.conflictProvider, offlineMutationOptions, this.inputMapper);
        if (!offlineMutationOptions.update && this.mutationCacheUpdates) {
            offlineMutationOptions.update = this.mutationCacheUpdates[offlineMutationOptions.context.operationName];
        }
        return offlineMutationOptions;
    };
    return ApolloOfflineClient;
}(apollo_client_1.default));
exports.ApolloOfflineClient = ApolloOfflineClient;
